import React, { useMemo, useState } from "react";
import { AppPage, MimaButton, MimaTable } from "../../../components";
import constant from "../../../utils/constant";
import moment from "moment";
import MimaOptionMenu from "../../../components/OptionMenu";
import { AnimatePresence } from "framer-motion";
import {
  CreateCompetitionContainer,
  EditCompetitionContainer,
} from "../../../containers";
import { amountFormatter } from "../../../utils/utils";

const Competitions = ({
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
  createCompetitionModal,
  closeModal,
  goToCreateCompetition,
  editCompetitionModal,
  goToEditCompetition,
}) => {
  const [selectedCompetition, setSelectedCompetition] = useState({});
  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.competitions || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Competition Name",
      accessor: "name",
    },

    {
      Header: "Total Prize",
      accessor: "winningAmount",
      Cell: ({ cell }) => {
        const winningAmount = cell.row.original.winningAmount;
        const currencyCode = cell.row.original.currencyCode;

        return (
          <span>{amountFormatter(currencyCode).format(winningAmount)}</span>
        );
      },
    },
    {
      Header: "Registration Start Date",
      accessor: "registrationStartDate",
      Cell: ({ cell }) => {
        const registrationStartDate = cell.row.original.registrationStartDate;

        return (
          <span>
            {moment(registrationStartDate).format("DD/MM/YYYY h:m a")}
          </span>
        );
      },
    },
    {
      Header: "Registration End Date",
      accessor: "registrationEndDate",
      Cell: ({ cell }) => {
        const registrationEndDate = cell.row.original.registrationEndDate;

        return (
          <span>{moment(registrationEndDate).format("DD/MM/YYYY h:m a")}</span>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.row.original.status;
        const styleClass = `status ${status === "INACTIVE" ? "status__dark__yellow" : "status__green"}`;
        return <span className={styleClass}>{status}</span>;
      },
    },

    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <MimaOptionMenu
            options={[{ label: "Edit Competition", value: "Edit Competition" }]}
            onOptionSelected={(option) => {
              if (option.value === "Edit Competition") {
                setSelectedCompetition(item);
                goToEditCompetition();
              }
            }}
          />
        );
      },
    },
  ];
  return (
    <AppPage pageTitle="Competitions">
      <MimaButton
        title="Create Competition"
        mt={3}
        mb={3}
        onClick={goToCreateCompetition}
      />
      <MimaTable
        tableData={tableData}
        tableColumns={tableColumns}
        searchPlaceholder="Search Competition"
        searchVariant="wide"
        totalItems={data?.data?.totalCounts}
        onLimitChange={onLimitChange}
        isLoading={isLoading}
        isFetching={isFetching}
        limit={limit}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setSearchQuery={setSearchQuery}
      />

      {(createCompetitionModal || editCompetitionModal) && (
        <div className="modal">
          <AnimatePresence>
            {createCompetitionModal && (
              <CreateCompetitionContainer closeModal={closeModal} />
            )}
            {editCompetitionModal && (
              <EditCompetitionContainer
                closeModal={closeModal}
                selectedCompetition={selectedCompetition}
              />
            )}
          </AnimatePresence>
        </div>
      )}
    </AppPage>
  );
};
export default Competitions;
